var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMax = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "arrow-up-right-and-arrow-down-left-from-center"
}, /*#__PURE__*/React.createElement("path", {
  id: "Primary",
  d: "M11.2188 7.71875C10.925 8.0125 10.925 8.4875 11.2188 8.77812C11.5125 9.06875 11.9875 9.07187 12.2781 8.77812L16.4969 4.55938V7.25C16.4969 7.66563 16.8313 8 17.2469 8C17.6625 8 17.9969 7.66563 17.9969 7.25V2.75C17.9969 2.33437 17.6625 2 17.2469 2H12.75C12.3344 2 12 2.33437 12 2.75C12 3.16562 12.3344 3.5 12.75 3.5H15.4406L11.2188 7.71875ZM8.78125 12.2812C9.075 11.9875 9.075 11.5125 8.78125 11.2219C8.4875 10.9313 8.0125 10.9281 7.72188 11.2219L3.5 15.4406V12.75C3.5 12.3344 3.16562 12 2.75 12C2.33437 12 2 12.3344 2 12.75V17.25C2 17.6656 2.33437 18 2.75 18H7.25C7.66563 18 8 17.6656 8 17.25C8 16.8344 7.66563 16.5 7.25 16.5H4.55938L8.78125 12.2812Z",
  fill: "white"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMax);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "5d7dccc695fffdc330ed104864ed5b1f.svg";